export const theme = {
    fondo: '#F9F9F9',
    colorPrimario: '#5B69E2',
    colorSecundario: '#000',
    verde: '#0C763D',
    verdeFecha: '#055E2E',
    verdeClaro: '#3CD54B',
    rojo: '#E34747',
    grisClaro: '#E8EFF1',
    grisClaro2: '#CBDDE2',
    azulClaro: '#0A4EA6',
    azulFuerte: '#0F2746',
    azulFuerteHover: '#1B4D8D'
}

export default theme;